module.exports = __webpack_public_path__ + "fonts/Inter-600-latin-ext62.ad4eb06.woff2";